var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var IntervalISO_1;
import { DateTime, Interval } from "luxon";
import { Field, InputType, ObjectType } from "type-graphql";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { IsAfterDateTime, IsBeforeDateTime, } from "../validation/beforeAfter.js";
let IntervalISO = IntervalISO_1 = class IntervalISO {
    start;
    end;
    get interval() {
        return Interval.fromDateTimes(this.start, this.end);
    }
    static init(start, end) {
        const self = new IntervalISO_1();
        self.start = start;
        self.end = end;
        return self;
    }
    static fromInterval(interval) {
        return this.init(interval.start, interval.end);
    }
};
__decorate([
    IsBeforeDateTime("end", true),
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", DateTime)
], IntervalISO.prototype, "start", void 0);
__decorate([
    IsAfterDateTime("start", true),
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", DateTime)
], IntervalISO.prototype, "end", void 0);
IntervalISO = IntervalISO_1 = __decorate([
    ObjectType(),
    InputType("IntervalISOInput")
], IntervalISO);
export { IntervalISO };
//# sourceMappingURL=IntervalISO.js.map